import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { FontStyleSheet } from '../../../../models/menu/font-style-sheets';

@Component({
  selector: 'app-render-font-so-it-loads-into-dom',
  templateUrl: './render-font-so-it-loads-into-dom.component.html',
  styleUrl: './render-font-so-it-loads-into-dom.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class RenderFontSoItLoadsIntoDomComponent {
  @Input() fontStyleSheets: FontStyleSheet[];
  preloadText: string = 'p';
}
